import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getCaseDetails, getCaseProfile } from "../api/caseService";

// Friendly field labels replacing raw backend/Tencent OCR field names,
// mirroring the data shown in admin.js and adminCaseProfile.js but
// simplified for a non-technical client audience.
const FIELD_LABELS = {
  id_name: "Full Name (from ID)",
  id_number: "ID Number",
  id_address: "Registered Address",
  id_sex: "Gender",
  id_nation: "Nationality",
  id_birth: "Date of Birth",
  id_authority: "Issued By",
  id_valid_date: "ID Valid Until",
};

export default function CaseDetails() {
  const { caseId } = useParams();
  const [caseData, setCaseData] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getCaseDetails(caseId), getCaseProfile(caseId)])
      .then(([caseRes, profileRes]) => {
        setCaseData(caseRes.data);
        setProfile(profileRes.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [caseId]);

  if (loading) return <p>Loading case details...</p>;
  if (!caseData) return <p>Case not found.</p>;

  return (
    <div>
      <Link to="/ekyc" style={{ color: "#0b2545", fontSize: 13 }}>
        &larr; Back to overview
      </Link>

      <h2 style={{ color: "#0b2545", marginTop: 12 }}>
        Verification Details — {caseData.expert_name || "Unnamed Expert"}
      </h2>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Identity Information</h3>
        <table className="data-table">
          <tbody>
            {Object.entries(FIELD_LABELS).map(([key, label]) => (
              <tr key={key}>
                <th style={{ width: "40%" }}>{label}</th>
                <td>{caseData[key] || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {profile && (
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Additional Background Details</h3>
          <table className="data-table">
            <tbody>
              <tr><th>Home Address</th><td>{profile.home_address || "-"}, {profile.city || ""} {profile.state || ""} {profile.zip || ""}</td></tr>
              <tr><th>Country</th><td>{profile.country || "-"}</td></tr>
              <tr><th>Undergraduate</th><td>{profile.ug_school || "-"} ({profile.ug_degree || "-"}, {profile.ug_year || "-"})</td></tr>
              <tr><th>Postgraduate</th><td>{profile.pg_school || "-"} ({profile.pg_degree || "-"}, {profile.pg_year || "-"})</td></tr>
              <tr><th>Current Employer</th><td>{profile.employer1_name || "-"}</td></tr>
              <tr><th>Previous Employer</th><td>{profile.employer2_name || "-"}</td></tr>
              <tr><th>Pending Litigation</th><td>{profile.has_pending_litigation ? "Yes" : "No"}</td></tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
